import React, { ReactElement } from 'react'
import StatisticsRowItem from '../RowItem/StatisticsRowItem'
import RowFont from '../RowFont'

type Props = {
    winCounter: string | number
    lossCounter?: string | number
    drawCounter?: string | number
    format: 'WDL' | 'WL' | 'WLD' | 'W'
    width: number | number[]
}

const ResultCounter = ({
    format,
    winCounter,
    drawCounter = 0,
    lossCounter = 0,
    width,
}: Props): ReactElement => {
    const value = format
        .split('')
        .map(char => {
            if (char === 'W') {
                return winCounter
            }
            if (char === 'L') {
                return lossCounter
            }
            return drawCounter
        })
        .join('-')
    return (
        <StatisticsRowItem width={width}>
            <RowFont>{value}</RowFont>
        </StatisticsRowItem>
    )
}

export default ResultCounter
